// extracted by mini-css-extract-plugin
module.exports = {"cellHead":"cellHead___2oTbY"};